import { useCallback } from 'react'
import { Eye } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { useCreateModel } from './context'

export function ImportMode() {
  const { state, dispatch } = useCreateModel()

  const handlePaste = useCallback(async () => {
    try {
      const text = await navigator.clipboard.readText()
      dispatch({ type: 'SET_IMPORT_URL', payload: text })
    } catch {
      // clipboard permission denied
    }
  }, [dispatch])

  return (
    <>
      {/* Link Input */}
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-foreground">
          Link to the model
        </label>
        <div className="relative">
          <Input
            placeholder="https://civitai.com/models/..."
            value={state.importUrl}
            onChange={(e) => dispatch({ type: 'SET_IMPORT_URL', payload: e.target.value })}
            className="pr-16"
          />
          <button
            type="button"
            onClick={handlePaste}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-normal text-foreground hover:text-foreground/80"
          >
            Paste
          </button>
        </div>
        <p className="text-sm text-muted-foreground">
          You may copy it from Civitai and other platforms
        </p>
      </div>

      {/* Preview */}
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium text-foreground">Preview</p>
        <div className="h-[280px] w-[304px] overflow-hidden rounded-lg bg-muted">
          {state.importPreviewUrl ? (
            <img
              src={state.importPreviewUrl}
              alt="Model preview"
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full flex-col items-center justify-center gap-2">
              <Eye className="h-4 w-4 text-muted-foreground" />
              <p className="text-sm text-muted-foreground">
                Preview will be here
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
